import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../../providers/tools/tools';
import { ModalController } from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';

@Component({
  selector: 'emoji-picker-component',
  templateUrl: 'emoji-picker.html',
})
export class EmojiPickerComponent {
  log = debug('app:EmojiPickerComponent');

  @Output() navToReplies = new EventEmitter();
  @Input() message: any = {};
  @Input() hideReplyButton: boolean = false;
  @Input() conversation: any = {};
  @Input() showEmojiSelectIcon: boolean = true;
  @Input() poll = false;
  reactions = [];
  repliesCount: number = 0;
  messageId: string;
  selectedEmojis: {
    [key: string]: {
      type: string;
      value: number;
      selected: boolean;
      userIds: any[];
    };
  } = {};
  toggled: boolean = false;
  loading = true;
  refreshInterval = null;
  subs = [];

  constructor(
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    public crudApi: CrudApiProvider,
    public liveChat: LiveChatProvider
  ) {}

  ngOnInit() {
    this.repliesCount = _.size(_.get(this.message, 'replies'));
    this.messageId = _.get(this.message, '_id');
    this.reactions = _.get(this.message, 'reactions');
    this.mapReactions();

    this.subs.push(
      this.liveChat.on(`socket--reaction--${this.messageId}`, data => {
        // this.log('r.value', this.messageId, data);
        this.reactions = data?.reactions;
        this.mapReactions();
      })
    );

    this.subs.push(
      this.liveChat.on(`socket--reaction--${this.messageId}`, data => {
        // this.log('r.value', this.messageId, data);
        this.reactions = data?.reactions;
        this.mapReactions();
      })
    );

    this.subs.push(
      this.tools.on('selected-emoji', data => {
        this.log('selected-emoji', data, this.messageId);
        if (data?.messageId === this.messageId) {
          this.selectEmoji(data.emoji);
        }
      })
    );
  }

  ngOnDestroy() {
    clearInterval(this.refreshInterval);
    this.refreshInterval = null;
  }

  mapReactions() {
    let mappedEmojies = _.mapKeys(this?.reactions, r => {
      // this.log('r.value', r.value, r.type);
      r.selected = !!_.includes(r.users, this.userProvider.get('_id'));
      return r.type;
    });
    this.selectedEmojis = mappedEmojies;
  }

  mapSelected() {
    return this.selectedEmojis;
  }

  selectEmoji(emoji) {
    if (!this.showEmojiSelectIcon) {
      return;
    }
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-emojiPicker-selectEmoji`
    );
    this.tools.emit('close-emoji-slider');

    const userId = this.userProvider.get('_id');
    if (this.selectedEmojis[emoji]) {
      if (this.selectedEmojis[emoji].selected) {
        const userIds = _.get(this.selectedEmojis[emoji], 'userIds');
        _.set(this.selectedEmojis[emoji], 'userIds', _.pull(userIds, userId));
        this.selectedEmojis[emoji].value--;
        this.selectedEmojis[emoji].selected = false;
        if (this.selectedEmojis[emoji].value === 0) {
          delete this.selectedEmojis[emoji];
        }
      } else {
        this.selectedEmojis[emoji].value++;
        this.selectedEmojis[emoji].userIds.push(userId);
        this.selectedEmojis[emoji].selected = true;
      }
    } else {
      this.selectedEmojis[emoji] = {
        type: emoji,
        value: 1,
        userIds: [userId],
        selected: true,
      };
    }

    this.message.reactions = this.getSelectedEmojis(true);

    // todo hit api
    try {
      const addRemove = this.selectedEmojis[emoji].selected ? 'add' : 'remove';
      this.log('addRemove', addRemove);
      this.liveChat.addReaction(this.messageId, addRemove, emoji);
    } catch (e) {
      this.log('addRemove | e', e);
    }
    this.toggled = false;
  }

  openEmojiSlider() {
    this.tools.emit('open-emoji-slider', this.message);
  }

  getSelectedEmojis(remap: boolean = false) {
    const currentUserId = _.get(this, 'userProvider.info._id');
    if (remap) {
      return Object.keys(this.selectedEmojis).map(
        key => this.selectedEmojis[key]
      );
    } else {
      if (this.selectedEmojis && Object.keys(this.selectedEmojis).length > 0) {
        _.forOwn(this.selectedEmojis, (emoji, key) => {
          if (_.includes(emoji.userIds, currentUserId)) {
            emoji.selected = true;
          }
        });
      }
      return Object.keys(this.selectedEmojis);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/emoji-picker/emoji-picker.ts